import React from "react";
import Logo from "../components/Logo";
import Navigation from "../components/Navigation";

const About = () => {
  return (
    <div>
      <Logo />
      <Navigation />
      <h1>A propos</h1>
      <br />
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
        quia culpa beatae deleniti dignissimos veniam debitis veritatis
        temporibus, repellendus nihil ea omnis cum hic praesentium quisquam ad
        fugiat! Labore ipsa perspiciatis, aut esse odio repellendus distinctio
        doloremque sint provident doloribus blanditiis, quaerat rerum. Facere
        harum in ratione eos, minima blanditiis dicta ad minus quos temporibus
        adipisci excepturi ab exercitationem iure esse enim, natus repellat
        error reiciendis iusto. Dicta quibusdam, ipsum enim doloribus veritatis
        officia voluptas, similique in veniam sed possimus? Magnam voluptates
        reiciendis, non ipsum, fugiat minus quasi architecto deleniti voluptate
        quis officia corporis natus veniam dicta excepturi atque commodi?
      </p>
      <br />
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure dicta
        accusantium et natus recusandae nostrum, aperiam assumenda vitae enim
        explicabo atque quod dolorem asperiores placeat officia deserunt earum
        corporis ea repellat harum ab odio qui! Quam ad ducimus, dolorem
        exercitationem non et aliquam labore magni enim doloribus qui accusamus
        assumenda est officiis, quisquam aspernatur suscipit corporis dolorum a
        dicta cupiditate incidunt laborum. Debitis corporis aliquam consectetur
        dolores aspernatur minus repellat explicabo iste nisi facilis, aperiam
        deserunt ipsa? Ipsa minus numquam a, nemo adipisci blanditiis
        consequatur cumque earum magnam iste esse. Eveniet praesentium qui
        deleniti, assumenda minima similique voluptas culpa quidem quibusdam
        illum consequuntur molestiae officiis laudantium? Voluptatem ea dolor
        veniam ab nemo suscipit natus odit laudantium aliquam, nulla corporis
        magnam assumenda corrupti, quam totam, asperiores similique labore.
        Quaerat magnam aut voluptatum dicta autem, esse cupiditate ipsam
        blanditiis repudiandae rem. Provident dolor, inventore quisquam culpa
        voluptates officiis incidunt odio, in natus dolorem accusamus aspernatur
        eveniet illo magni a maiores repellendus fuga aut dolorum explicabo
        cumque est accusantium tempora. Rem veniam ad facere placeat ab qui
        similique esse unde eius sapiente eum corrupti harum nesciunt,
        temporibus nam dolore quos! Id voluptatibus ipsam soluta atque iure
        expedita facere alias. Provident assumenda est fugit.
      </p>
    </div>
  );
};

export default About;
